(ns client-portal.client.root
  (:require [client-portal.client.layout :as l]
            [client-portal.client.conversations.list.views :refer [conversations-list-root]]
            [client-portal.client.drive-thru.locations.list.views :refer [drive-thru-locations-list-root]]
            [client-portal.client.drive-thru.locations.individual.views :refer [drive-thru-location-root]]
            [client-portal.client.voice-insights.views :as vi]
            [client-portal.client.voice-insights.sessions.views :as vi.sessions]
            [client-portal.client.voice-insights.locations.views :as vi.locations]
            [client-portal.client.voice-insights.items.views :as vi.items]
            [client-portal.client.voice-insights.ces.views :as vi.ces]
            [client-portal.client.voice-insights.duration.views :as vi.duration]
            [client-portal.client.voice-insights.upsell.views :as vi.upsell]
            [client-portal.client.voice-insights.ai-analyst.views :as vi.ai-analyst]
            [client-portal.client.ai-agent.views :as ai-agent]
            [client-portal.client.voice-commerce.dashboard.views :as vc.dashboard]
            [client-portal.client.voice-commerce.orders.views :as vc.orders]
            [client-portal.client.oasys.views :as oasys]
            [client-portal.client.products.data]
            [client-portal.client.reports.list.views :as reports.list]
            [client-portal.client.reports.individual.views :as reports.individual]
            [client-portal.client.router :as router]
            [client-portal.client.routes :as routes]
            [shared.core.components.auth0.data :as auth0.d]
            [shared.core.account.data :as account.d]
            [shared.core.amelia-light.components.components :as alc]
            [shared.core.components.components :as c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.debug.views :refer [debug-toolbar]]
            [shared.core.toasts.data]
            [shared.core.keybind.data]
            [keybind.core :as key]
            [shared.core.util :as util]))

(defn not-found []
  [:div {:style {:flex 1
                 :display :flex
                 :flex-direction :column}}
   [l/core-header]
   [:div {:style {:flex 1
                  :display :flex
                  :flex-direction :column
                  :align-items :center
                  :justify-content :center
                  :gap 8
                  :padding "40px 30px 90px"}}
    [:div {:style {:color (style/alc-color "Text/primary_header")
                   :font-size 100
                   :font-weight style/font-bold-weight
                   :line-height 1.2}}
     "404"]
    [:div {:style {:color (style/alc-color "Text/secondary")
                   :font-size 20
                   :font-weight 400
                   :line-height 1.4
                   :text-align :center}}
     "We couldn't find the page you're looking for."]
    [alc/purple-button {:style {:margin-top 16}
                        :size :large
                        :on-click #(re/dispatch [:router/go [:home]])}
     "Take me home"]]])

(defn auth-error [{:keys [error error-description]
                   :or {error "Unknown Error Occurred"}}]
  [l/content-with-logo-in-corner {:logo-on-click #(re/dispatch [:auth0/login-with-redirect])}
   [c/error-message {:style {:font-size 24
                             :font-weight style/font-semi-bold-weight
                             :margin-top 30}}
    error]
   (when error-description
     [c/error-message {:style {:font-size 18
                               :margin-top 20}}
      error-description])
   [c/primary-button {:on-click #(do
                                   (re/dispatch [:auth0/logout])
                                   (re/dispatch [:auth0/login-with-redirect]))
                      :style {:margin-top 30}}
    "Try Again"]])

(defn inner-current-root-view [_]
  (let [cur-route- (re/subscribe [:router/current-route-])
        user-details- (re/subscribe [:account/user-details-])
        token-claims- (re/subscribe [:auth0/token-claims-])
        roles- (re/subscribe [:account/user-roles-])
        core-route-access- (re/subscribe [:account/core-route-access-])
        nav-list- (re/subscribe [:reports/nav-list-])
        products- (re/subscribe [:products/list-])
        cid- (re/subscribe [:concepts/current-concept-id-])
        auth-state* (re/ratom nil)]
    (re/create-class
      {:component-did-mount #(key/bind! "defmod-shift-1"
                                        ::debug-toolbar
                                        (fn [] (re/dispatch [:debug/toggle-toolbar])))
       :component-will-unmount #(key/unbind! "defmod-shift-1" ::debug-toolbar)
       :component-did-update (fn [this]
                               (let [{:keys [auth0]} (re/props this)]
                                 (re/dispatch [:auth0/set-auth-details auth0])))
       :reagent-render (fn [{:keys [auth0]}]
                         (let [{:keys [error is-authenticated is-loading login-with-redirect]} auth0
                               [route-name params query] @cur-route-
                               token-claims (when is-authenticated @token-claims-)
                               user-details (when is-authenticated @user-details-)
                               products (when is-authenticated @products-)
                               is-loading (or is-loading
                                              (and is-authenticated (or (not token-claims)
                                                                        (util/loading? user-details)
                                                                        (not user-details)
                                                                        (util/loading? products)
                                                                        (not products))))
                               url-params (util/window-url-params)
                               state-param (:state url-params)
                               error-param (:error url-params)
                               query (some-> query (util/->kebab-case-keywords))
                               authed? (and is-authenticated (not is-loading))
                               nav-list-pending? (and authed?
                                                      @cid-
                                                      (= (str @cid-) (str (:cid query)))
                                                      (util/nil-or-loading? @nav-list-))
                               current-route-path (or (router/route->path route-name params)
                                                      (.. js/window -location -pathname))
                               matching-report (when (and authed? current-route-path)
                                                 (some->> (util/when-not-loading @nav-list-)
                                                          (some (fn [r]
                                                                  (when (= current-route-path (get-in r [:navigation-configuration :route]))
                                                                    r)))))
                               force-login? (or (and @auth-state* state-param (not= state-param @auth-state*))
                                                (not state-param))]
                           (when (and authed? matching-report (= route-name :not-found))
                             (re/dispatch [:router/set-current-route
                                           [(router/path->route-name (-> matching-report :navigation-configuration :route))
                                            nil
                                            query]]))
                           [:div {:style {:background-color (style/alc-color "Background/page")
                                          :display :flex
                                          :height "100%"
                                          :width "100%"}}
                            [debug-toolbar]
                            (cond
                              (and authed? matching-report
                                   (account.d/has-route-access? routes/routes route-name @roles-))
                              [reports.individual/root (merge query params {:report-id (:public-id matching-report)
                                                                            :all-reports-button? false})]

                              (and authed? (= route-name :not-found) (util/nil-or-loading? @nav-list-))
                              [reports.individual/root (merge query {:cid (:cid url-params)
                                                                     :all-reports-button? false})]

                              (and authed? nav-list-pending?)
                              [l/with-loading-header {}]

                              authed?
                              (if (account.d/has-route-access? routes/routes route-name @roles-)
                                (case route-name
                                  :home (do
                                          (when-let [first-route (some-> @core-route-access- (first))]
                                            (let [first-route-config (some->> first-route (get routes/routes))]
                                              (if-let [route-dispatch (:dispatch first-route-config)]
                                                (re/dispatch route-dispatch)
                                                (re/dispatch [:router/go [first-route]]))))
                                          [l/with-loading-header {}])

                                  #_conversations
                                  :conversations/list [conversations-list-root query]

                                  #_drive-thru
                                  :drive-thru/locations-list [drive-thru-locations-list-root query]
                                  :drive-thru/location [drive-thru-location-root query]

                                  #_voice-commerce
                                  :vc [vc.dashboard/root query]
                                  :vc/orders [vc.orders/root query]

                                  #_vi
                                  :vi [vi/root query]
                                  :vi/locations [vi.locations/root query]
                                  :vi/sessions [vi.sessions/root query]
                                  :vi/items [vi.items/root query]
                                  :vi/ces [vi.ces/root query]
                                  :vi/duration [vi.duration/root query]
                                  :vi/upsell [vi.upsell/root query]
                                  :vi/ai-analyst [vi.ai-analyst/root query]
                                  :ai-agent/new [ai-agent/root-with-agent-context query]
                                  :ai-agent/session [ai-agent/root-with-agent-context (merge query params)]
                                  :vi/agent [ai-agent/root-with-agent-context query]
                                  :vi/agent-session [ai-agent/root-with-agent-context (merge query params)]

                                  #_oasys
                                  :oasys/assistant-view [oasys/root query]

                                  #_reports
                                  :reports/list [reports.list/root query]
                                  :reports/individual [reports.individual/root (merge query params)]
                                  :reports/individual-session [reports.individual/root (merge query params)]
                                  ;; Edit flow: the full-page report builder on a session
                                  ;; pre-created from the report (see :reports/edit-report).
                                  :reports/individual-edit [ai-agent/root-with-agent-context (merge query params)]
                                  ;; New-report flow: the full-page report builder on a fresh
                                  ;; session with the report-builder agent.
                                  :reports/new [ai-agent/root-with-agent-context query]
                                  :reports/new-session [ai-agent/root-with-agent-context (merge query params)]

                                  :not-found [not-found]
                                  [:div])
                                (do
                                  (re/dispatch [:router/go [:home]])
                                  [l/with-loading-header {}]))

                              is-loading
                              [l/with-loading-header {}]

                              (or error-param error)
                              [auth-error query]

                              :else
                              (do
                                (when (and force-login? login-with-redirect)
                                  (reset! auth-state* state-param)
                                  (login-with-redirect (auth0.d/build-redirect-app-state {:current-route @cur-route-})))
                                [:div {:style {:background-color (style/color :primary :darker-1)
                                               :height "100%"
                                               :width "100%"}}]))]))})))

(defn current-root-view [props]
  (c/auth0-root-view inner-current-root-view props))
